<ng-container *transloco="let t; read: 'alerts.dialog'">
  <app-modal
    [(open)]="open"
    [title]="rule() ? t('editTitle') : t('addTitle')"
    size="small"
    (closed)="onClose()"
  >
    <form [formGroup]="form" (ngSubmit)="onSubmit()" class="flex flex-col gap-4">
      <app-form-field
        [error]="
          nameError() ??
          (form.controls.name.invalid && form.controls.name.touched ? t('nameRequired') : null)
        "
      >
        <app-text-input
          [label]="t('name')"
          [placeholder]="t('namePlaceholder')"
          formControlName="name"
          [invalid]="!!nameError() || (form.controls.name.invalid && form.controls.name.touched)"
        ></app-text-input>
      </app-form-field>

      <app-form-field [label]="t('metric')">
        <app-select
          [options]="metricOptions()"
          [placeholder]="t('metricPlaceholder')"
          formControlName="metric"
          [invalid]="form.controls.metric.invalid && form.controls.metric.touched"
        ></app-select>
      </app-form-field>

      @if (isConditionless()) {
        <div class="rounded-control bg-sunken px-4 py-3 text-[13px] leading-5 text-ink-2">
          {{ t('offlineHint') }}
        </div>
      } @else {
        <app-form-field [label]="t('condition')">
          <app-select
            [options]="operatorOptions()"
            [placeholder]="t('conditionPlaceholder')"
            formControlName="operator"
            [invalid]="form.controls.operator.invalid && form.controls.operator.touched"
          ></app-select>
        </app-form-field>

        <app-form-field
          [error]="
            form.controls.threshold.invalid && form.controls.threshold.touched
              ? t('thresholdRequired')
              : null
          "
        >
          <app-number-input
            [label]="t('threshold')"
            [unit]="thresholdUnit()"
            formControlName="threshold"
            [invalid]="form.controls.threshold.invalid && form.controls.threshold.touched"
          ></app-number-input>
        </app-form-field>
      }

      <div class="flex items-center justify-between pt-1">
        <div>
          <div class="text-[14px] font-semibold text-ink-1">{{ t('enabled') }}</div>
          <div class="text-[12px] text-ink-2">{{ t('enabledHint') }}</div>
        </div>
        <app-toggle formControlName="enabled"></app-toggle>
      </div>
    </form>

    <ng-template modalFooter>
      <div class="flex flex-1 items-center justify-end gap-2">
        <button
          type="button"
          (click)="onClose()"
          class="rounded-control border border-hairline bg-card px-4 py-2 text-[13px] font-semibold text-ink-1 hover:bg-sunken"
        >
          {{ t('cancel') }}
        </button>
        <button
          type="button"
          (click)="onSubmit()"
          [disabled]="form.invalid || busy()"
          class="rounded-control bg-action px-4 py-2 text-[13px] font-semibold text-action-text disabled:opacity-40 hover:brightness-90"
        >
          {{ rule() ? t('save') : t('create') }}
        </button>
      </div>
    </ng-template>
  </app-modal>
</ng-container>
